import React from 'react';
import { ProjectScreen, InviteScreen, InviteSuccess, MilestoneScreen, PaymentMethodScreen, PaymentScreen, ProjectChanges } from './Project';
import { HowItWorksScreen, DisputeQuestions, DisputePayment } from '../Disputes';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import NavOptions from '../../constants/NavOptions';

const Stack = createStackNavigator();

const ProjectStack = ({ navigation }) => {

  return (
    <Stack.Navigator initialRouteName='Project' screenOptions={NavOptions.all}>
      <Stack.Screen
        name='Project'
        component={ProjectScreen}
        options={{ headerShown: false, title: 'Project' }}
      />
      <Stack.Screen
        name='InviteScreen'
        component={InviteScreen}
        options={{ headerShown: false, title: 'Invite' }}
        initialParams={{ inviteType: 'Project' }}
      />
      {/* <Stack.Screen
        name='Invite2'
        component={InviteScreen2}
        options={{ headerShown: true, title: '' }}
      /> */}
      <Stack.Screen
        name='InviteSuccess'
        component={InviteSuccess}
        options={{ headerShown: false, title: 'Invite Success' }}
      />
      <Stack.Screen
        name='Milestone'
        component={MilestoneScreen}
        options={{ headerShown: false, title: 'Milestone' }}
      />
      <Stack.Screen
        name='PaymentMethod'
        component={PaymentMethodScreen}
        options={{ headerShown: false, title: 'Payment Methods' }}
      />
      <Stack.Screen
        name='Payment'
        component={PaymentScreen}
        options={{ headerShown: false, title: 'Payment' }}
      />
      <Stack.Screen
        name='ProjectChanges'
        component={ProjectChanges}
        options={{ headerShown: false, title: 'Project Changes' }}
      />
      <Stack.Screen
        name='HowDisputesWorkScreen'
        component={HowItWorksScreen}
        options={{ headerShown: true, title: "How Disputes Work" }}
      />
      <Stack.Screen
        name='DisputeQuestions'
        component={DisputeQuestions}
        options={{ headerShown: true, title: 'Dispute Questions' }}
      />
      <Stack.Screen
        name='DisputePayment'
        component={DisputePayment}
        options={{ headerShown: true, title: 'Dispute Payment' }}
      />
    </Stack.Navigator>
  )

}

export default ProjectStack;
